import { TStockImport } from "@helpers/validation-schemas/warehouse-and-inventory/stock-import.schema";
import { useGetAllStockBalancesQuery } from "@states/warehouse-and-inventory/stock-balance.api";
import { useGetAllStockImportsQuery } from "@states/warehouse-and-inventory/stock-import.api";
import { TSuccessResponse } from "@type-defs/general/TSuccessResponse";

const useGetAllStockBalances = (args: {
  page?: number;
  limit?: number;
  search?: number | string;
}) => {
  const {
    data: rawData,
    error,
    isLoading,
    refetch,
    isFetching,
  } = useGetAllStockBalancesQuery({ ...args });

  const stockBalanceResponse = rawData as any as TSuccessResponse<any>;

  return {
    stockBalanceData: stockBalanceResponse?.data,
    stockBalanceMessage: stockBalanceResponse?.message,
    stockBalanceSuccess: stockBalanceResponse?.success,
    stockBalancePaginator: stockBalanceResponse?.paginator,
    stockBalanceError: error,
    stockBalanceLoading: isLoading,
    stockBalanceRefetch: refetch,
    stockBalanceFetching: isFetching,
  };
};

export default useGetAllStockBalances;
